import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedUserType } from "../../store/slices/userSlice";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import "./userTypeSelection.css";
import { appInsights } from "../../AppInsights";

const UserTypeSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const { userData, loading } = useSelector((state) => state.user);
  const userType = localStorage.getItem("userType");
  const userTypeRole = userData?.userTypes?.find((type) =>
    type?.userType?.toLowerCase()?.includes(userType?.toLowerCase())
  );
  const projectType = [...userData?.userTypes] // <- clone it first
    .sort((a, b) => a?.userTypeId - b?.userTypeId)
    .map((role) => role);
  const isSuperAdmin = userTypeRole?.userTypeRoleId === 1;
  const isHR = [2].includes(userTypeRole?.userTypeRoleId);
  const isAccounts = [3].includes(userTypeRole?.userTypeRoleId);

  // Redirect if user doesn't have multiple types
  if (!userData?.userTypes || userData?.userTypes.length <= 1) {
    navigate(
      isSuperAdmin
        ? "/admin/timesheet-list"
        : isAccounts
        ? "/user/employees/timesheets"
        : isHR
        ? "/hr/employees/timesheets"
        : "/user/timesheet"
    );
    return null;
  }

  const handleUserTypeSelect = (userType) => {
    try {
      localStorage.setItem(
        "userType",
        userType?.userTypeId === 1 ? "internal" : "external"
      );
      localStorage.setItem("userTypeId", userType?.userTypeId);
      dispatch(setSelectedUserType(userType?.userTypeId));

      // Find the role for the selected user type
      const selectedRole = userData?.userTypes?.find(
        (type) => type?.userTypeId === userType?.userTypeId
      );
      const isHR = selectedRole?.userTypeRoleId === 2;
      const isAccounts = selectedRole?.userTypeRoleId === 3;

      // Navigate based on the selected role
      if (selectedRole?.userTypeRoleId === 1) {
        navigate("/admin/timesheet-list");
      } else if (isAccounts) {
        navigate("/user/employees/timesheets");
      } else if (isHR) {
        navigate("/hr/employees/timesheets");
      } else {
        navigate("/user/timesheet");
      }
    } catch (error) {
      appInsights.trackException("Select Project Type", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };

  const getIconForUserType = (userType) => {
    if (userType?.userTypeId === 1) {
      return "pi pi-building"; // Internal User
    }
    if (userType?.userTypeId === 2) {
      return "pi pi-users"; // External User
    }
    return "pi pi-id-card";
  };

  // const getCardDescription = (userType) => {
  //     if (userType.userTypeId === 1) {
  //         return 'Access internal Projects';
  //     }
  //     if (userType.userTypeId === 2) {
  //         return 'Access external Projects';
  //     }
  //     return `Access timesheet as ${userType.userType}`;
  // };

  const getCardTitle = (userType) => {
    if (userType?.userTypeId === 1) {
      return "Internal Projects";
    }
    if (userType?.userTypeId === 2) {
      return "External Projects";
    }
    return `User Type: ${userType?.userType}`;
  };

  return (
    <div className="user-type-selection">
      <Toast ref={toast} />
      <div className="selection-container">
        <h2>Select Project Type</h2>
        <p>
          Please choose the projects you wish to complete the timesheet for.
        </p>
        <div className="selection-cards">
          {projectType?.map((userType) => (
            <Card key={userType?.userTypeId} className="selection-card">
              <div className="card-content">
                <i
                  className={`${getIconForUserType(userType)} selection-icon`}
                ></i>
                <h3>{getCardTitle(userType)}</h3>
                {/* <p>{getCardDescription(userType)}</p> */}
                <Button
                  label={`Continue`}
                  className={
                    userType?.userTypeId === 1
                      ? "p-button-primary"
                      : "p-button-secondary"
                  }
                  onClick={() => handleUserTypeSelect(userType)}
                  disabled={loading}
                />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserTypeSelection;
